const i18n = {
  fallbackLng: 'en',
  supportedLngs: ['en', 'pt', 'es'],
  defaultNS: 'common',
}

export const NEXT_LOCALE = '__NEXT_LOCALE__'

export default i18n
